import React from "react";
import { Formik } from "formik";
import Yup from "yup";
import styled from "styled-components";
import { media } from "../../utils/style";
import Fieldset from "../Fieldset";
import Button from "../Button";
import spaceDust from "../../images/space-dust-3.png";

const Form = styled.form`
  background: #262168;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.35);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  margin: 0;
  max-width: 400px;
  padding: 15px 20px 20px;
  position: relative;
  width: 100%;

  &:after {
    background-image: url(${spaceDust});
    background-repeat: no-repeat;
    background-size: contain;
    content: '';
    height: 2441px;
    position: absolute;
    right: -775px;
    top: -650px;
    width: 1796px;
    z-index: -1;
  }

  ${media.tablet`
    margin-left: 20px;
    padding: 35px 40px 40px; 
  `};
`;

const equalTo = (ref, msg) => {
  return Yup.mixed().test({
    name: "equalTo",
    exclusive: false,
    message: msg,
    params: {
      reference: ref.path
    },
    test: function(value) {
      return value === this.resolve(ref);
    }
  });
};

Yup.addMethod(Yup.string, "equalTo", equalTo);

const ResetPasswordForm = props => {
  const {
    values,
    touched,
    isValid,
    errors,
    handleChange,
    handleBlur,
    handleSubmit
  } = props;

  return (
    <Form onSubmit={handleSubmit}>
      <Fieldset
        id="password"
        type="password"
        label="New Password"
        placeholder="New Password"
        error={touched.password && errors.password}
        value={values.password}
        onChange={handleChange}
        onBlur={handleBlur}
      />

      <Fieldset
        id="confirmPassword"
        type="password"
        label="Confirm New Password"
        placeholder="Confirm New Password"
        error={touched.confirmPassword && errors.confirmPassword}
        value={values.confirmPassword}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      <Button type="submit" disabled={!isValid}>
        Set New Password
      </Button>
    </Form>
  );
};

export default Formik({
  validationSchema: Yup.object().shape({
    password: Yup.string().required("Password is required"),
    confirmPassword: Yup.string()
      .equalTo(Yup.ref("password"), "Passwords don't match")
      .required("Confirmation Password is required")
  }),
  mapPropsToValues: () => {
    return {
      password: "",
      confirmPassword: ""
    };
  },
  handleSubmit: (values, { props, resetForm }) => {
    props.handleSubmit(values, resetForm);
  },
  validateOnChange: true
})(ResetPasswordForm);



// WEBPACK FOOTER //
// ./src/components/ResetPasswordForm/index.jsx